if (!window.ProductForm) {
  window.ProductForm = class ProductForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector('form');
    this.form.querySelector('[name=id]').disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
    this.productNotification = document.querySelector('product-notification');
    this.bosapinUtils = document.querySelector('bosapin-utils');
    this.submitButton = this.querySelector('[type="submit"]');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    let buyingQty = parseInt(document.querySelector('.quantity__input').value);
    let available = parseInt(localStorage.getItem('availableQty'));
    let variantID = document.getElementsByName("id")[0].value;
    let cart = localStorage.getItem('cart');
    let parsedCart = JSON.parse(cart);
    let qtyDivError = document.getElementById('overlay-product');
    if (document.getElementById("postal-code__disabled")) {

      //Do we have enough stock?
      if (available < buyingQty) {
        qtyDivError.style.display = 'block';
        return false;
      }
      qtyDivError.style.display = "none";
    }

    if (document.getElementById('main-cart-footer')) {
      //In cart verification
      if (cart) {
        for (var key of parsedCart) {
          if (variantID == key.variant_id) {
            if (available < (buyingQty + key.quantity)) {
              alert("Not enough quantity" + available);
              return false;
            }
          }
        }
      }
    }
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.handleErrorMessage();
    if (this.cartNotification) {
      this.cartNotification.setActiveElement(document.activeElement);
    }

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    if (this.cartNotification) {
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
    }
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        this.handleErrorMessage(response.description);

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (!soldOutMessage) return;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.querySelector('span').classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        this.error = true;
        return;
      }

      this.error = false;
      const quickAddModal = this.closest('quick-add-modal');
      localStorage.setItem('availableQty', available - buyingQty);
      qtyDivError.style.display = "none";
      const afterAddtoCartPopup = document.querySelector('#popup-after-add-to-cart');
      if (quickAddModal) {
        document.body.addEventListener('modalClosed', () => {
          setTimeout(() => {
            this.cartNotification.renderContents(response);
            localStorage.setItem('added-to-cart-once', 'true');
            if (afterAddtoCartPopup) {
              this.bosapinUtils.getCartData().then((response) => response.json()).then((response) => {
                if (response.items_subtotal_price < 10000) {
                  window.showAfterAddToCartPopup();
                }
              });
            }
          });
        }, {
          once: true
        });
        quickAddModal.hide(true);
      } else {
        if (this.cartNotification) {
          this.cartNotification.renderContents(response);
        }
        if (this.productNotification) {
          this.productNotification.setType('success');
          this.productNotification.setMessage(window.currentPageStrings.product.added_to_cart);
          this.productNotification.show();
        }
        localStorage.setItem('added-to-cart-once', 'true');
        if (afterAddtoCartPopup) {
          this.bosapinUtils.getCartData().then((response) => response.json()).then((response) => {
            if (response.items_subtotal_price < 10000) {
              window.showAfterAddToCartPopup();
            }
          });
        }
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.submitButton.classList.remove('loading');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
  };
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', window.ProductForm);
}

if (!customElements.get('product-form-upsell')) {
  customElements.define('product-form-upsell', class ProductFormUpsell extends window.ProductForm {
    onSubmitHandler(evt) {
      evt.preventDefault();
      let buyingQty = parseInt(document.querySelector('.quantity__input').value);
      let available = parseInt(localStorage.getItem('availableQty'));
      let variantID = document.getElementsByName("id")[0].value;
      let cart = localStorage.getItem('cart');
      let parsedCart = JSON.parse(cart);
      let qtyDivError = document.getElementById('overlay-product');
      if (document.getElementById("postal-code__disabled")) {

        //Do we have enough stock?
        if (available < buyingQty) {
          qtyDivError.style.display = 'block';
          return false;
        }
        qtyDivError.style.display = "none";
      }

      if (document.getElementById('main-cart-footer')) {
        //In cart verification
        if (cart) {
          for (var key of parsedCart) {
            if (variantID == key.variant_id) {
              if (available < (buyingQty + key.quantity)) {
                alert("Not enough quantity" + available);
                return false;
              }
            }
          }
        }
      }
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      if (this.cartNotification) {
        this.cartNotification.setActiveElement(document.activeElement);
      }

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cartNotification) {
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      }
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        }

        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        localStorage.setItem('availableQty', available - buyingQty);
        qtyDivError.style.display = "none";
        const afterAddtoCartPopup = document.querySelector('#popup-after-add-to-cart');

        const $upsellMode = document.querySelector('upsell-mode');
        $upsellMode.switchToCollection(true, true);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
    }
  });
}